/**
 * @module
 * @name LoaderSmall
 * @description Spinner, loader
 */
export default {
  name: 'LoaderSmall'
}
